export default __webpack_public_path__ + "static/media/ga.b5b9b62f.svg";